import React, { useState } from "react"
import { Link } from "react-router-dom"
import Back from "../common/Back"
import img from "../images/about.jpg"
import { authFetch } from "../../lib/api"
import "./auth.css"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const res = await authFetch("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Request failed")
        return
      }
      setSubmitted(true)
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className='auth-section'>
      <Back name='Forgot password' title='Reset your password' cover={img} />
      <div className='auth-page'>
        <div className='container'>
          <div className='auth-card'>
            <h1 className='auth-card__title'>Forgot password?</h1>
            <p className='auth-card__subtitle'>
              {submitted
                ? "If an account exists for that email, we’ve sent a reset link."
                : "Enter your email and we’ll send you a link to reset your password."}
            </p>

            {error && <p className='auth-error'>{error}</p>}

            {!submitted ? (
              <>
                <form onSubmit={handleSubmit} className='auth-form'>
                  <label htmlFor='forgot-email'>Email</label>
                  <input
                    id='forgot-email'
                    type='email'
                    placeholder='you@example.com'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type='submit' className='auth-form__submit' disabled={loading}>
                    {loading ? "Sending…" : "Send reset link"}
                  </button>
                </form>
                <div className='auth-footer'>
                  Remember your password? <Link to='/signin'>Sign in</Link>
                </div>
              </>
            ) : (
              <div className='auth-footer' style={{ borderTop: "none", paddingTop: 0 }}>
                <Link to='/signin'>Back to sign in</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ForgotPassword
